import React, { Children, Fragment, cloneElement } from 'react';

import { AsyncLoader } from 'Components/widgets/loading/async-loader/AsyncLoader';

export const SpinnerHandler = ({ children, isLoading, ...props }) =>
  isLoading ? (
    <AsyncLoader />
  ) : (
    <Fragment>{Children.map(children, (child) => child && cloneElement(child, props))}</Fragment>
  );
